<!-- <div class="panel-heading" style="color:#ffffff;background-color: #354D6A;" title="DASHBOARD">
  <div class="page-titlehead">
    DASHBOARD
  </div>
</div> -->


<div style="padding-top:0.8%;" class="container-fluid">

  <div class="row">


    <div class="col-xl-3 col-md-6 mb-2">
      <div class="card shadow h-100 py-2" style="background-color: #a5d1fc;">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col mr-2">
              <div class="icolor text-uppercase" title="COJ Active Projects">COJ Active Projects
              </div>
              <div class="row no-gutters align-items-center">
                <div class="col-auto">
                  <div title="{{PendingProjectCount}}" class="h5 mb-0 mr-3 icolor">{{PendingProjectCount}}</div>
                </div>
              </div>
            </div>
            <div class="col-auto">
              <img border="0" src="../assets/images/InfrastructureProjects.png" alt="COJ Active Projects"
                title="COJ Active Projects">
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-xl-3 col-md-6 mb-2">
      <div class="card shadow h-100 py-2" style="background-color: #69d0d7;">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col mr-2">
              <div class="icolor text-uppercase mb-1" title="COJ Completed Projects">COJ Completed Projects
              </div>
              <div class="row no-gutters align-items-center">
                <div class="col-auto">
                  <div title="{{ProjectsCompletedCount}}" class="h5 mb-0 mr-3 icolor">{{ProjectsCompletedCount}}</div>
                </div>
              </div>
            </div>
            <div class="col-auto">
              <img border="0" src="../assets/images/PublicSafety.png" alt="COJ Completed Projects"
                title="COJ Completed Projects">
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-xl-3 col-md-6 mb-2">
      <div class="card shadow h-100 py-2" style="background-color: #6cd4a8;">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col mr-2">
              <div class="icolor text-uppercase mb-1" title="COJ Total Projects">COJ Total Projects
              </div>
              <div class="row no-gutters align-items-center">
                <div class="col-auto">
                  <div title="{{TotalProjectsCount}}" class="h5 mb-0 mr-3 icolor">{{TotalProjectsCount}}</div>
                </div>
              </div>
            </div>
            <div class="col-auto">
              <img border="0" src="../assets/images/total.png" alt="COJ Total Projects" title="COJ Total Projects">
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-xl-3 col-md-6 mb-2">
      <div class="card shadow h-100 py-2" style="background-color: #ffd280;">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col mr-2">
              <div class="icolor text-uppercase mb-1" title="Estimated Gross Proceeds to City of Jacksonville">Estimated
                Gross
                Proceeds to
                City of Jacksonville
              </div>
              <div class="row no-gutters align-items-center">
                <div class="col-auto">
                  <div class="h5 mb-0 mr-3 icolor">{{TotalCIPBudgetAmount}}</div>
                </div>
              </div>
            </div>
            <div class="col-auto">
              <img border="0" src="../assets/images/GrossProceeds.png"
                alt="Estimated Gross Proceeds to City of Jacksonville"
                title="Estimated Gross Proceeds to City of Jacksonville">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="panel-heading" style="color:#ffffff;background-color: #11263f;" title="PROJECT METRICS">
    <div class="page-titlehead">
      PROJECT METRICS
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="pt-3">
        <!-- <h2 class="h6 mb-3 text-dark text-center">Project Metrics</h2> -->
        <div class="max-height-for-scroll">

          <h4 class="small text-uppercase icolor">Projects Not Started <span class="float-right"
              style="margin-right:3.1%;">{{ProjectsFutureCount}}</span></h4>
          <div class="mb-4 progressbarwidth">
            <mat-progress-bar mode="mode" [value]="((ProjectsFutureCount/TotalProjectsCount)*100).toFixed(0)"
              [bufferValue]="100">
            </mat-progress-bar>
            <span class="progressbarspace"
              [style.left]="true?getFututeLeft():getFututeLeft() ">{{TotalProjectsCount !== 0?((ProjectsFutureCount/TotalProjectsCount)*100).toFixed(0):0}}%</span>
          </div>

          <h4 class="small text-uppercase icolor">Projects in Planning <span class="float-right"
              style="margin-right:3.1%;">{{ProjectsPlanningCount}}</span></h4>
          <div class="mb-4 progressbarwidth">
            <mat-progress-bar mode="mode" [value]="((ProjectsPlanningCount/TotalProjectsCount)*100).toFixed(0)"
              [bufferValue]="100">
            </mat-progress-bar>
            <span class="progressbarspace"
              [style.left]="true?getPlanningLeft():getPlanningLeft() ">{{TotalProjectsCount !== 0?((ProjectsPlanningCount/TotalProjectsCount)*100).toFixed(0):0}}%</span>
          </div>
          <h4 class="small text-uppercase icolor">Projects in Design <span style="margin-right:3.1%;"
              class="float-right">{{ProjectsDesignCount}}</span></h4>
          <!-- <div class="progress mb-4"> -->
          <div class="mb-4" style="position: relative;width: 97%">
            <mat-progress-bar mode="mode" [value]="((ProjectsDesignCount/TotalProjectsCount)*100).toFixed(0)"
              [bufferValue]="100">
            </mat-progress-bar>
            <span style="position: absolute; top: -0.22em;margin-left: 0.3%;"
              [style.left]="true?getDesignLeft():getDesignLeft()">{{TotalProjectsCount !== 0?((ProjectsDesignCount/TotalProjectsCount)*100).toFixed(0):0}}%</span>
          </div>

          <h4 class="small text-uppercase icolor">Projects in Construction<span style="margin-right:3.1%;"
              class="float-right">{{ProjectsConstructionCount}}</span></h4>
          <div class="mb-4" style="position: relative;width: 97%">
            <mat-progress-bar mode="mode" [value]="((ProjectsConstructionCount/TotalProjectsCount)*100).toFixed(0)"
              [bufferValue]="100">
            </mat-progress-bar>
            <span style="position: absolute; top: -0.22em;margin-left: 0.3%;"
              [style.left]="true?getConstructionLeft():getConstructionLeft()">{{TotalProjectsCount !== 0?((ProjectsConstructionCount/TotalProjectsCount)*100).toFixed(0):0}}%</span>
          </div>


          <h4 class="small text-uppercase icolor">Projects Completed<span style="margin-right:3.1%;"
              class="float-right">{{ProjectsCompletedCount}}</span></h4>
          <div class="mb-4" style="position: relative;width: 97%">
            <mat-progress-bar mode="mode" [value]="((ProjectsCompletedCount/TotalProjectsCount)*100).toFixed(0)"
              [bufferValue]="100">
            </mat-progress-bar>
            <span style="position: absolute; top: -0.22em;margin-left: 0.3%;"
              [style.left]="true?getCompletedLeft():getCompletedLeft()">{{TotalProjectsCount !== 0?((ProjectsCompletedCount/TotalProjectsCount)*100).toFixed(0):0}}%</span>
          </div>
          <!-- <mat-progress-bar [mode]="mode" [value]="((ProjectsDesignCount/TotalProjectsCount)*100)"
              [bufferValue]="100">
            </mat-progress-bar> -->
          <!-- <div class="progress-bar pcolor" role="progressbar" style="width: 100%"
              [aria-valuenow]="ProjectsDesignCount" [aria-valuemin]="0" [aria-valuemax]="TotalProjectsCount"> -->
          <!-- </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="col-lg-6">

      <div class="pt-3">
        <div class="max-height-for-scroll">
          <!-- <h4 class="small text-uppercase icolor">Projects On-hold<span style="margin-right:7%;"
              class="float-right">{{ProjectsHoldCount}}</span>
          </h4>
          <div class="mb-4" style="position: relative;width: 94%">
            <mat-progress-bar mode="mode" [value]="((ProjectsHoldCount/TotalProjectsCount)*100).toFixed(0)"
              [bufferValue]="100">
            </mat-progress-bar>
            <span style="position: absolute; top: -0.22em;"
              [ngStyle]="{'left': ((ProjectsHoldCount/TotalProjectsCount)*100).toFixed(0) +'%'}">{{TotalProjectsCount !== 0?((ProjectsHoldCount/TotalProjectsCount)*100).toFixed(0):0}}%</span>
          </div> -->

          <!-- <h4 class="small text-uppercase icolor">Projects Not Feasible<span style="margin-right:7%;"
              class="float-right">{{ProjectsNotFeasibleCount}}</span></h4>
          <div class="mb-4" style="position: relative;width: 94%">
            <mat-progress-bar mode="mode" [value]="((ProjectsNotFeasibleCount/TotalProjectsCount)*100).toFixed(0)"
              [bufferValue]="100">
            </mat-progress-bar>
            <span style="position: absolute; top: -0.22em;"
              [ngStyle]="{'left': ((ProjectsNotFeasibleCount/TotalProjectsCount)*100).toFixed(0) +'%'}">{{TotalProjectsCount !== 0?((ProjectsNotFeasibleCount/TotalProjectsCount)*100).toFixed(0):0}}%</span>
          </div> -->


        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 rounded" style="background-color: #11263f;">

    <div class=" col-lg-7 row rounded ptheader" style="background-color: #11263f;">
      <div class="col-3 d-flex align-items-center justify-content-center">
        <div style="background-color: #e7e9f2;" class="d-block rounded px-3 py-3 icolor">
          {{PendingProjectCount}}
        </div>
        <div class="ml-3 small text-uppercase text-white">Active Projects</div>
      </div>

      <div class="col-3 d-flex align-items-center justify-content-center">
        <div style="background-color: #e7e9f2;" class="d-block rounded px-3 py-3 icolor">
          {{ProjectsCompletedCount}}
        </div>
        <div class="ml-3 small text-uppercase text-white">Completed Projects</div>
      </div>

      <div class="col-3 d-flex align-items-center justify-content-center">
        <div style="background-color: #ffd280;" class="d-block rounded px-3 py-3 icolor">
          {{ProjectsFutureCount}}
        </div>
        <div class="ml-3 small text-uppercase text-white">Future Projects</div>
      </div>

      <div class="col-3 d-flex align-items-center justify-content-center">
        <div style="background-color: #6cd4a8;" class="d-block rounded px-3 py-3 icolor">
          {{TotalProjectsCount}}
        </div>
        <div class="ml-3 small text-uppercase text-white">Total Projects</div>
      </div>
    </div>
    <div class="col-lg-6" style="background-color: #11263f;">

    </div>

  </div>



  <div class="row pt-3">

    <div class="col-12">
      <div class="shadow mb-2">
        <div class="panel-heading" style="color:#ffffff;background-color: #11263f;" title="PROJECTS">
          <div class="page-titlehead">
            PROJECTS

          </div>
        </div>
        <app-gridmenu></app-gridmenu>
        <!-- <app-user-maintenance></app-user-maintenance> -->
        <!-- Card Content - Collapse -->

      </div>
    </div>

  </div>

  <div class="row">
    <div style="width: 100%;">

      <div class="panel-heading model-content" style="margin-bottom: 0.5%;">
        <div class="my-container" style="background-color:white;">
          <div class="modal-body" role="contentinfo">
            <p class="model-content" tabindex="0">
              <span style="font-weight:500;font-size:16px;line-height: 1.0000143;color:#2355b7;">
                <strong
                  title="DISCLAIMER: This estimated gross proceeds shown here are being used for various capital improvement projects.  This website has been established in an effort to inform members of the public on the summary of the anticipated cost, progress and status of all local option gas tax funded projects along with their respective timelines, contractors and Jacksonville Small and Emerging Businesses (JSEB) participants.">
                </strong><span style="text-decoration: underline;">DISCLAIMER:</span> This estimated gross proceeds
                shown here are being used for various capital
                improvement projects. This website has been established in an effort to inform members of the public
                on the summary of the anticipated cost, progress and status of all local option gas tax funded
                projects along with their respective timelines, contractors and Jacksonville Small and Emerging
                Businesses (JSEB) participants.
              </span>
            </p>
            <div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
